var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuAdditional = function SvgMenuAdditional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#menu-additional_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.626 8.068A4.41 4.41 0 0 1 13 4.225a4.41 4.41 0 0 1 4.375 3.852c1.047.04 1.838.157 2.504.524.57.314 1.06.749 1.438 1.268-.28.273-.578.567-.608.597l-2.786 2.78c-1.29 1.288-2.217 2.212-3.016 2.821-.787.6-1.382.84-2 .84-.617 0-1.213-.24-1.999-.84-.8-.609-1.727-1.533-3.016-2.82l-3.28-3.275a4.4 4.4 0 0 1 1.51-1.37c.663-.367 1.457-.49 2.504-.534m1.167-.02.411.003.619.002h4.36q.55 0 1.026.002A3.26 3.26 0 0 0 13 5.373 3.26 3.26 0 0 0 9.793 8.05",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.88 10.92-3.175 3.17c-1.251 1.25-2.232 2.229-3.1 2.89-.89.677-1.727 1.075-2.698 1.075s-1.808-.398-2.697-1.075c-.868-.661-1.849-1.64-3.1-2.89l-3.035-3.03c-.147.483-.187 1.009-.171 1.62.018.727.119 1.63.247 2.784l.006.051c.105.943.187 1.684.3 2.279.116.606.272 1.104.545 1.55a4.4 4.4 0 0 0 1.892 1.69c.474.222.987.321 1.603.37.605.046 1.351.046 2.302.046h4.403c.95 0 1.697 0 2.301-.047.617-.048 1.13-.147 1.604-.369A4.4 4.4 0 0 0 21 19.344c.273-.446.428-.944.544-1.55.114-.595.196-1.336.3-2.279l.006-.05c.129-1.155.23-2.058.248-2.784.017-.671-.033-1.24-.217-1.76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu-additional_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export { SvgMenuAdditional as ReactComponent };